import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageBanner from "../../../assets/images/andorra-license test-banner.png";
import SEO from "../../../utils/SEO";

export default function AndorraCarLicense (){
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.andorra-car-license.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>

            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/andorra-car-license"
            />

            <IntroSection
                title={tp('intro.title')}
                description={tp('intro.description')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/andorra-car-license-hero.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        subtitle={tp('why.subtitle')}
                        blocks={[{ items: obj('why.items') }]}
                    />

                    <BannerPageImg src={PageBanner} />


                    <InfoBlocks
                        title={tp('application.title')}
                        subtitle={tp('application.subtitle')}
                        blocks={[{ items: obj('application.items') }]}
                    />


                    <FeatureCards
                        title={tp('steps.title')}
                        subtitle={tp('steps.subtitle')}
                        features={obj('steps.items')}
                    />

                    <LocationTimeline
                        title={tp('benefit.title')}
                        item={obj('benefit.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    <DetailsSection
                        title={tp('whyUs.title')}
                        subtitle={tp('whyUs.subtitle')}
                        items={obj('whyUs.items')}
                    />

                    {/* Final CTA */}
                    <CTA title={tp('cta.title')}
                         description={tp('cta.description')}
                         buttonText={tp('cta.button')}
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};
